export const points = [
  {
    name: "OP tokens",
    logo: "/points/op.svg",
    collateralVaults: ["0x7650D7ae1981f2189d352b0EC743b9099D24086F"],
  },
] as const
